import styled, { css } from 'styled-components'

import { Color } from 'constants/color'

export const Title = styled.h5`
    color: ${Color.white};
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 20px;
`

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`

export const Button = styled.button`
    background-color: ${Color.ohGreen};
    color: ${Color.white};
    font-family: Avenir;
    font-weight: 700;
    border: none;
    cursor: pointer;
    height: 40px;
    border-radius: 4px;
    outline: none;
    padding: 10px;
    text-transform: lowercase;
`

export const ItemContainer = styled.div`
    display: flex;
    position: relative;
`

export const ItemImageContainer = styled.div`
    position: relative;
    justify-content: center;
    align-items: center;

    width: 220px;
    height: 220px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;

    &:hover .expand-icon-container {
        display: flex !important;
    }
`

export const Item = styled.img`
    width: 100%;
    height: 100%;
    transform: none !important;
`

export const MaximizeIconContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${Color.transparentBlack};
    display: none !important;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`

export const MaximizeIcon = styled.img`
    width: 24px;
    height: 24px;
    cursor: pointer;
    filter: brightness(0) invert(1);
`

export const MinimizeIcon = styled(MaximizeIcon)`
    filter: brightness(0);
`

export const SliderContainer = styled.div`
    background: ${Color.unknownColor19};
    ${props =>
        props.isPaginationRequired
            ? css`
                  margin: 0 32px;
              `
            : null};
`

export const Details = styled.div`
    text-transform: lowercase;
    display: flex;

    flex-direction: column;
    margin: ${props => (props.isPaginationRequired ? '0 12px' : '0 10px')};
    margin-top: 8px;
`

export const DetailInfo = styled.span`
    display: block;
    font-size: 12px;
    line-height: 16px;
    color: ${Color.white};
`

export const ControlContainer = styled.div`
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const FallbackContainer = styled(ItemImageContainer)`
    background-color: ${Color.alternateGrey};
    color: ${Color.ohGrey};
    font-weight: 500;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
`
